const updatePlacesStr = {
  toastr: 'Updated place',
  toastr1: 'has been updated successfully',
  toastrError: 'Place already registered',
  toastrError1: 'Enter another name'
};

export default updatePlacesStr;
